import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import { useTheme } from "theme/useTheme";
import ProposalsEditRecipientsSelectContacts from "../step-1-recipients/ProposalsEditRecipientsSelectContacts";
import SendOutlined from "@mui/icons-material/SendOutlined";
import TextField from "@mui/material/TextField";
import { useProposalsEditReviewStore } from "./ProposalsEditReviewStore";
import ButtonWithProgress from "reusable/mui/progress-button/ButtonWithProgress";
import { useProposalsEditRecipientsStore } from "../step-1-recipients/ProposalsEditRecipientsStore";
import ProposalsEditReviewAttachments from "./ProposalsEditReviewAttachments";

export default observer(function ProposalsEditReviewSidebar() {
   const theme = useTheme()
   const proposalsEditReviewStore = useProposalsEditReviewStore()
   const proposalsEditRecipientsStore = useProposalsEditRecipientsStore()

   const recipientsLength = proposalsEditRecipientsStore.fields.recipientUserIds.length

   return <>
      <Stack sx={{ mb: 4 }}>
         <Stack sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: .5 }}>
               Send with a personal message
            </Typography>
            <Typography variant="caption" sx={{ color: theme.palette.primary.light }}>
               Each recipient will receive an email with a link to this proposal and any personal message you include here.
            </Typography>
         </Stack>
         {proposalsEditReviewStore.formHandler.personalMessage.bindInput((ip) => <TextField
            {...ip}
            label="A brief message to your client"
            multiline
            minRows={2}
         />)}
      </Stack>
      <Stack sx={{ mb: 4 }}>
         <ProposalsEditReviewAttachments />
      </Stack>
      <Stack sx={{ mb: 4 }}>
         <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 3 }}>
            Recipients
         </Typography>
         <ProposalsEditRecipientsSelectContacts />
      </Stack>
      <Stack sx={{ flexDirection: 'row', justifyContent: 'right', gap: 1 }}>
         <ButtonWithProgress
            loading={proposalsEditReviewStore.sendTestEmailLoader.isLoading}
            onClick={proposalsEditReviewStore.sendTestEmail}>
            Send test email
         </ButtonWithProgress>
         <ButtonWithProgress
            loading={proposalsEditReviewStore.sendEmailLoader.isLoading}
            onClick={proposalsEditReviewStore.sendEmail}
            disabled={recipientsLength === 0}
            variant="contained"
            icon={<SendOutlined />}
            iconAndLoadingPosition='end'>
            {recipientsLength === 0 && 'Send'}
            {recipientsLength === 1 && 'Send to 1 person'}
            {recipientsLength > 1 && `Send to ${recipientsLength} people`}
         </ButtonWithProgress>
      </Stack>
   </>
})
